import React from 'react';
import { OPERATION_TYPE } from "../../../../../../util/varibles/constants";
import { IOperation } from "../../../../../../util/varibles/interface";
import Event from "./Event";
import Harvest from "./Harvest";
import Service from "./Service";
import Support from './Support';
import Transport from "./Transport";
import Treatment from "./Treatment";
import Unavailable from "./Unavailable";

export interface IPropsOp {
    data: IOperation
    isOwn: boolean
    isTimeline?: boolean
    readOnly?: boolean
    ignoreUnavailable?: boolean
}

const Operation: React.FC<IPropsOp> = (props) => {
    const { isOwn: isVesselOwn = false, permission } = props.data.vessel;
    const { operation_type, status } = props.data.operation;
    const operationType = (!props.ignoreUnavailable && !(isVesselOwn || permission) && !props.isOwn)
        ? OPERATION_TYPE.UNAVAILABLE
        : operation_type;

    const common = {
        ...props,
        isVesselOwn,
        permission,
        operationType,
        status,
    }

    switch (operationType) {
        case OPERATION_TYPE.HARVEST:
            return <Harvest {...common} />
        case OPERATION_TYPE.TREATMENT:
            return <Treatment {...common} />
        case OPERATION_TYPE.EVENT:
            return <Event {...common} />
        case OPERATION_TYPE.TRANSPORT:
            return <Transport {...common} />
        case OPERATION_TYPE.SERVICE:
            return <Service {...common} />
        case OPERATION_TYPE.SUPPORT:
            return <Support {...common} />
        default:
            return <Unavailable {...common} />
    }
};

export default Operation;
